const BACKEND_URL = 'https://ups-backend-j6hsamdnhq-el.a.run.app/infra'
const SECURITY_BACKEND_URL = 'https://ups-backend-j6hsamdnhq-el.a.run.app/security'
const AUTH_BACKEND_URL = 'https://ups-backend-j6hsamdnhq-el.a.run.app/auth/login';
const ACCESS_BACKEND_URL =  'https://ups-backend-j6hsamdnhq-el.a.run.app/access'
const ACCESS_TOKEN_LOCALSTORAGE_KEY = 'access_token';
const FRONTEND_URL = 'https://ups.platform.infra.apna.co'
const ASIA_SOUTH1_ACTIVE_COST_RATE = 0.023
const ASIA_SOUTH1_LONG_TERM_COST_RATE = 0.016 
export { BACKEND_URL, AUTH_BACKEND_URL, ACCESS_TOKEN_LOCALSTORAGE_KEY, FRONTEND_URL, ASIA_SOUTH1_ACTIVE_COST_RATE,ASIA_SOUTH1_LONG_TERM_COST_RATE, SECURITY_BACKEND_URL , ACCESS_BACKEND_URL};
 
